module.exports = __webpack_public_path__ + "img/bay.e7dae47e.svg";